export enum APP_CONFIG_FLAGS {
  DOFR_APPEAL_AGENT_ENABLED = "DOFR_APPEAL_AGENT_ENABLED",
  CHAT_EXPERIMENTS_ENABLED = "CHAT_EXPERIMENTS_ENABLED",
  HOME_V2_ENABLED = "HOME_V2_ENABLED",
  ZAMMAD_ENABLED = "ZAMMAD_ENABLED",  // Ticketing master switch (Tickets tab, or Contact Support when V1 is on)
  APP_TICKETING_V1_ENABLED = "APP_TICKETING_V1_ENABLED", // Show legacy Contact Support instead of the Tickets tab (needs ZAMMAD_ENABLED)
  APP_TABS_VISIBILITY_CONTROLLER = "APP_TABS_VISIBILITY_CONTROLLER",
  APP_CLAIM_TIMELINE_ACTIONS_ENABLED = "APP_CLAIM_TIMELINE_ACTIONS_ENABLED"
}
